/* This example requires Tailwind CSS v2.0+ */
import { Fragment } from "react";
import { Disclosure, Menu, Transition } from "@headlessui/react";
import { BellIcon, MenuIcon, XIcon } from "@heroicons/react/outline";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function Navbar({ appName, roomName, DEADSIMPLESCREENSHARING_MODE, brandName, ownBranding }) {
  return (
    <div className="bg-gray-900 h-10 text-white flex items-center px-4">
      <div className="font-bold flex-1">
        {DEADSIMPLESCREENSHARING_MODE ? "DeadSimpleScreenSharing" : appName}
      </div>

      <div className="font-bold">{ownBranding ? brandName : "Metered Video"}</div>
    </div>
  );
}

export default Navbar;
